export default function GetCurrentCognitoDetailsMethod() {
  console.log(window.location.hostname);

  switch (window.location.hostname) {

    case "www.uat.portal.rcshealth.io":
    case "uat.portal.rcshealth.io":
      // case "localhost":
      // return {
      //   userPoolId: 'us-east-1_6akZvn2KK',
      //   userPoolClientId: 'mcmiat7es6epa631lmcqnk1ui',
      //   // signUpVerificationMethod: 'code',
      //   multifactor: {
      //     mode: 'OPTIONAL',
      //     totp: true,
      //     email: true
      //   },
      //   identityPoolId: 'us-east-1:e7be7878-12af-4d1e-b378-1a5f72a3794a' // Replace with your actual Identity Pool ID
      // };
        return {
        userPoolId: 'us-east-1_KpEBIH5vY',
        userPoolClientId: '2b9glph8dc8j2qr447fpfsjp0u',
        // signUpVerificationMethod: 'code',
        multifactor: {
          mode: 'OPTIONAL',
          totp: true,
          email: true
        },
        identityPoolId: 'us-east-1:153afa4d-be1c-4711-af35-e4cd7ebf4542' // Replace with your actual Identity Pool ID
      };

    case "www.dev.portal.rcshealth.io":
    case "dev.portal.rcshealth.io":
      case "localhost":
      // return {
      //   userPoolId: 'us-east-1_5i1ZQrSB7',
      //   userPoolClientId: '1lqm3j89d9ptbnf03hpcr31lip',
      //   // signUpVerificationMethod: 'code',
      //   multifactor: {
      //     mode: 'OPTIONAL',
      //     totp: true,
      //     email: true
      //   },
      //   identityPoolId: 'us-east-1:2ab11d67-fed1-4ce1-bdb9-7f3632c3161e' // Replace with your actual Identity Pool ID
      // };
       return {
        userPoolId: 'us-east-1_AqkTthDZE',
        userPoolClientId: '1cs0908v1j7c4dc9ja14ctqhvt',
        // signUpVerificationMethod: 'code',
        multifactor: {
          mode: 'OPTIONAL',
          totp: true,
          email: true
        },
        identityPoolId: 'us-east-1:14c09b15-f337-4a8c-9c70-18a54a1e11b6' // Replace with your actual Identity Pool ID
      };
    case "www.portal.rcshealth.io":
    case "portal.rcshealth.io":
    // case "localhost":
      return {
        userPoolId: 'us-east-1_6m7WMEQcd',
        userPoolClientId: 'blju3klm8m2444l2k52qh9hpt',
        // signUpVerificationMethod: 'code',
        multifactor: {
          mode: 'OPTIONAL',
          totp: true,
          email: true
        },
        identityPoolId: 'us-east-1:49278c14-0fdd-4172-bde0-844e76231967' // Replace with your actual Identity Pool ID
      };

    default:
      return {
        userPoolId: 'us-east-1_5i1ZQrSB7',
        userPoolClientId: '1lqm3j89d9ptbnf03hpcr31lip',
        // signUpVerificationMethod: 'code',
        multifactor: {
          mode: 'OPTIONAL',
          totp: true,
          email: true
        },
        identityPoolId: 'us-east-1:2ab11d67-fed1-4ce1-bdb9-7f3632c3161e' // Replace with your actual Identity Pool ID
      };
  }
}
